import { Box, Modal } from "@mui/material";
import { FaRegTrashAlt } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { useState } from "react";
import ModalConfirmationAction from "../../../common/particles.jsx/ModalConfirmationAction";
import { useMutation } from "@tanstack/react-query";
import { deleteInitialAnalysis } from "../../../../services/patientCare";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalDeleteAnalysis = ({
  open,
  setOpen,
  analysis,
  refetch,
  isDoctor,
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    mutateDelete({ id: analysis.id, is_doctor: isDoctor });
  };

  const { mutate: mutateDelete, isLoading } = useMutation({
    mutationFn: deleteInitialAnalysis,
    onSuccess: () => {
      refetch();
      setOpen(false);
      setOpenConfirm(true);
    },
  });

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            width: "30%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "50vh",
            padding: 0,
          }}
          className="text-left text-base"
        >
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="flex justify-between items-center px-8 py-4">
              <div className="w-12 h-12 bg-red-100 p-1 rounded-full">
                <div className="w-full h-full bg-red-300 p-2 rounded-full">
                  <FaRegTrashAlt className="w-full h-full text-red-600" />
                </div>
              </div>
              <RxCross1
                className="cursor-pointer hover:text-red-500"
                onClick={handleClose}
              />
            </div>

            <div className="px-8 mb-4">
              <p className="font-bold text-lg ">
                Hapus Informasi {isDoctor ? "Doctor" : "Initial"} Analysis
              </p>
              <p>
                Data {isDoctor ? "doctor" : "initial"} analysis tidak dapat
                dikembalikan
              </p>
            </div>

            <div className="px-8 mb-4 flex gap-2 items-center">
              <button
                type="button"
                className="w-full p-2 rounded-md border-2 border-black hover:bg-gray-300"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={
                  analysis === undefined ||
                  (analysis && analysis.id === undefined) ||
                  isLoading
                }
                className="w-full p-2 rounded-md border-2 border-red-500 bg-red-500 text-white hover:bg-gray-300 hover:border-gray-300 disabled:bg-gray-300 disabled:border-gray-300"
              >
                Delete
              </button>
            </div>
          </form>
        </Box>
      </Modal>

      <ModalConfirmationAction
        open={openConfirm}
        setOpen={setOpenConfirm}
        setOpenParent={setOpen}
        message={"Informasi Analysis Dihapus"}
      />
    </>
  );
};

export default ModalDeleteAnalysis;
